import type { InteractionDataByConnection } from "../../utils/filterInteractionRpcs";

export interface IAGAlgoDataRow {
  id: string;
  type: string;
  connection_id: string;
  portfolio: string;
  pnl: string;
  status: string;
  cpu_usage: string;
  ram_usage: string;
  strategy: string;
  strategy_instance_id: string;
  accounts: string[];
  create_time: string;
  update_time: string;
  original_data: any;
  visible_parameters: string[];
}

export const NEW_STRATEGY_ROW_ID = "__new_strategy__";

export const NEW_STRATEGY_PLACEHOLDER: IAGAlgoDataRow = {
  id: NEW_STRATEGY_ROW_ID,
  type: "",
  connection_id: "",
  portfolio: "",
  pnl: "",
  status: "",
  cpu_usage: "",
  ram_usage: "",
  strategy: "",
  strategy_instance_id: "",
  accounts: [],
  create_time: "",
  update_time: "",
  original_data: { __new: true },
  visible_parameters: [],
};

export type useAGTableProps = {
  dataMap: Map<string, IAGAlgoDataRow>;
  interactionsData?: InteractionDataByConnection;
};
